<template>
  <div>
    <div class="mx-auto">
      <elements-menu
        ref="elementsMenu"
        :substep="substep"
      />
      <groovemail-form
        :substep="substep"
        v-if="localModel && activePresetId && activePreset.styles && ready"
        :model='localModel'
      ></groovemail-form>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import ElementsMenu from '../pages/forms/elements-menu/ElementsMenu.vue';
import GroovemailForm from '@/components/GroovemailForm.vue';
import themeConfig from '@/theme/themeConfig.js';
// import Mailformstyle from '@/models/Mailformstyle';

export default {
  name: 'GroovemailFormVariants',

  props: {
    substep: {
      required: true,
    },
    model: {
      required: true,
    },
  },

  data(){
    return {
      loaderColor: themeConfig.appPrimaryColor,
      localModel: this.model,
      detailsOpen: false,
      ready: false,
    };
  },
  async created() {
    await this.loadPresets();
    this.ready = true;
    if (!this.localModel.default_preset || this.localModel.default_preset === '') {
      this.localModel.default_preset = this.activePresetId;
    }
    this.$root.$on('updateFormFields', (formFields) => this.localModel.form_fields = formFields);
  },
  computed: {
    ...mapGetters({
      activePreset: 'forms/activePreset',
    }),
    ...mapState({
      presets: state => state.forms.presets,
      loading: state => state.forms.loading,
      activePresetId: state => state.forms.activePresetId,
    }),
    tabs() {
      return this.variations.map(item => {
        const newItem = [];
        newItem['title'] = item.name;
        newItem['value'] = item.id;
        return newItem;
      });
    },
  },
  methods: {
    async loadPresets() {
      // set the active form id
      await this.$store.dispatch('forms/setActiveFormId', this.localModel.formid);

      if (this.$route.query?.preset) {
        await this.$store.dispatch('forms/loadPresets', this.$route.query.preset);
        await this.$store.dispatch('forms/setActivePreset', this.$route.query.preset);
        return;
      }
      if (this.localModel.default_preset !== '') {
        await this.$store.dispatch('forms/loadPresets', this.localModel.default_preset);
        await this.$store.dispatch('forms/setActivePreset', this.localModel.default_preset);
        return;
      }
      await this.$store.dispatch('forms/loadPresets');
      await this.$store.dispatch('forms/setActivePreset', this.presets[0].id);
    },
  },
  components: {
    GroovemailForm,
    ElementsMenu,
  },
};
</script>
